import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { $, removeClass } from '../../dom.js';

function removeFromParent(element) {
  try {
    if (element.parentElement) {
      element.parentElement.removeChild(element);
    }
  } catch (e) {// this will throw if this happens due to a blur event, nasty business
  }
}

export var RowCache = /*#__PURE__*/function () {
  function RowCache(renderers) {
    _classCallCheck(this, RowCache);

    this.renderers = renderers;
    this.cache = new Map();
  }
  /**
   * Returns a row either by creating a new one or reusing
   * a previously released row which shares the same templateId.
   */


  _createClass(RowCache, [{
    key: "alloc",
    value: function alloc(templateId) {
      var result = this.getTemplateCache(templateId).pop();

      if (!result) {
        var domNode = $('.monaco-list-row');
        var renderer = this.getRenderer(templateId);
        var templateData = renderer.renderTemplate(domNode);
        result = {
          domNode: domNode,
          templateId: templateId,
          templateData: templateData
        };
      }

      return result;
    }
    /**
     * Releases the row for eventual reuse.
     */

  }, {
    key: "release",
    value: function release(row) {
      if (!row) {
        return;
      }

      this.releaseRow(row);
    }
  }, {
    key: "releaseRow",
    value: function releaseRow(row) {
      var domNode = row.domNode,
          templateId = row.templateId;

      if (domNode) {
        removeClass(domNode, 'scrolling');
        removeFromParent(domNode);
      }

      var cache = this.getTemplateCache(templateId);
      cache.push(row);
    }
  }, {
    key: "getTemplateCache",
    value: function getTemplateCache(templateId) {
      var result = this.cache.get(templateId);

      if (!result) {
        result = [];
        this.cache.set(templateId, result);
      }

      return result;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _this = this;

      this.cache.forEach(function (cachedRows, templateId) {
        var _iterator = _createForOfIteratorHelper(cachedRows),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var cachedRow = _step.value;

            var renderer = _this.getRenderer(templateId);

            renderer.disposeTemplate(cachedRow.templateData);
            cachedRow.domNode = null;
            cachedRow.templateData = null;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      this.cache.clear();
    }
  }, {
    key: "getRenderer",
    value: function getRenderer(templateId) {
      var renderer = this.renderers.get(templateId);

      if (!renderer) {
        throw new Error("No renderer found for ".concat(templateId));
      }

      return renderer;
    }
  }]);

  return RowCache;
}();